import { ITableGroup } from '../components/base/Table/models/ITableGroup.js';

export const appendChildGroupFunctions = (grouping: ITableGroup): ITableGroup | null => {
	const { childGroup = null } = grouping;
	if (childGroup) {
		childGroup.fetchChildren = grouping && grouping.fetchChildren;
		childGroup.hideToggle = grouping && grouping.hideToggle;
		childGroup.disableToggle = grouping && grouping.disableToggle;
		return childGroup;
	}
	return null;
};
